import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { ChronoCode, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { field } from '../entity-maps';

/**
 * Codification temporelle
 * Réduit à son minimum pour utilisation par le moteur
 */
export class ChronocodeVO {
    
    protected _model: Model;
    public get model(): Model {
        return this._model;
    }
    public set model(value: Model) {
        this._model = value;
    }
    
    constructor(model: Model, pSource?: ChronoCode) {

        this._model = model;
        if (pSource) {
            this._source = pSource;
        } else {
            this._source = new ChronoCode();
            this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
    }

    /** Le VO source provenant du back  */
    private _source: ChronoCode;
    public set source(src: ChronoCode) {
        this._source = src;
    }
    public get source(): ChronoCode {
        return this._source;
    }

    public set domain(domain: string) {
        this._source.domain = domain;
    }
    public get domain(): string {
        return this._source.domain;
    }

    public get businessUnitCode(): string {
        return this._source.businessUnitCode;
    }
    public set businessUnitCode(businessUnitCode: string) {
        this._source.businessUnitCode = businessUnitCode;
    }

    public get parentCode(): string {
        return this._source.parentCode;
    }
    public set parentCode(parentCode: string) {
        this._source.parentCode = parentCode;
    }

    public get code(): string {
        return this._source.code;
    }
    public set code(code: string) {
        this._source.code = code;
    }

    public get shortCode(): string {
        return this._source.shortCode;
    }
    public set shortCode(shortCode: string) {
        this._source.shortCode = shortCode;
    }

    public get endDate(): number {
        return this._source.endDate;
    }
    public set endDate(endDate: number) {
        this._source.endDate = endDate;
    }

    public get startDate(): number {
        return this._source.startDate;
    }
    public set startDate(startDate: number) {
        this._source.startDate = startDate;
    }

    public get label(): TranslatedEmb {
        return this._source.label;
    }
    public set label(value: TranslatedEmb) {
        this._source.label = value;
    }

    public get rootCode(): string {
        return this._source.rootCode;
    }
    public set rootCode(rootCode: string) {
        this._source.code = rootCode;
    }

    public get level(): number {
        return this._source.level;
    }
    public set level(level: number) {
        this._source.level = level;
    }
    
    @field('string')
    public get color(): string {
        return this.source.color;
    }
    public set color(str: string) {
        this.source.color = str;
    }

    /**
     * Return translated label
     */
    public get trsLabel(): string {
        return 'TODO TODO';
    }

}
